<template>
  <div>
    <div class="top_bg">
      <img src="@/assets/images/product_bg.jpg" alt="">
    </div>
    <div class="company-list">
      <div class="defult_title">
        <h1>{{language === 'E' ? 'ABOUT KUN HENG' : '关于坤恒科技'}}</h1>
        <p>{{language === 'E' ? '关于坤恒科技' : 'ABOUT KUN HENG'}}</p>
      </div>
      <div class="defult_width">
        <h3>{{ company.name }}</h3>
        <h5>{{ company.title }}</h5>
        <div v-for="(item, key) in company.html" :key="key" class="company-box">
          <img v-if="item.img" :src="item.img"  alt="" class="company-img">
          <p v-else v-html="item">
          </p>
        </div>
        <!-- <ul class="contact-list">
          <li>
            <h5>北京公司：</h5>
            <p>北京市石景山区中海时代广场B座808</p>
            <p>Tel：010-67899833</p>
          </li>
            <li>
            <h5>深圳公司：</h5>
            <p>广东深圳市龙华区民治南源新村大厦1005 </p>
            <p>Tel：0755-83213768</p>
          </li>
          <li>
            <p>Email：info@kun-heng.com</p>
          </li>
        </ul>
        <ul class="contact-list">
          <li>
            <h5>香港公司：</h5>
            <p>香港干诺道中137-138号三台大厦1212 </p>
            <p>Tel：00852-21393077</p>
          </li>
        </ul> -->
      </div>
      <div class="industry-news-list">
        <div class="defult_title">
          <h1>{{language === 'E' ? 'COMPANY NEWS' : '公司新闻'}}</h1>
          <p>{{language === 'E' ? '公司新闻' : 'COMPANY NEWS'}}</p>
        </div>
        <el-row class="news-box defult_width">
          <ul>
            <li v-for="(item, index) in companyNewsList" :key="index">
              <router-link :to="`aboutMeDetail/${item.id}`" >
                <div class="img">
                  <img :src="item.img" alt="">
                </div>
                <div class="list">
                    <h5>
                    {{ item.name }}
                    </h5>
                    <p>
                      {{ (item.detail).substring(0, 200) + '...' }}
                    </p>
                    <span>{{language === 'E' ? 'Release Time：' : '发布时间：'}}{{ item.time.year + '/' + item.time.month}}</span>
                </div>
              </router-link>
            </li>
          </ul>
        </el-row>
      </div>
       <div class="join-us-box" v-if="positionList && positionList.length">
        <div class="defult_title">
          <h1>{{language === 'E' ? 'RECRUITENT POSITION' : '招聘职位'}}</h1>
          <p>{{language === 'E' ? '招聘职位' : 'RECRUITENT POSITION'}}</p>
        </div>
        <div class="container join-us defult_width">
            <div class="join-us-title">
                <ul>
                    <li>{{language === 'E' ? 'Job title' : '职位名称'}}</li>
                    <li>{{language === 'E' ? 'Workplace' : '工作地点'}}</li>
                    <li>{{language === 'E' ? 'Recruitment time' : '招聘时间'}}</li>
                    <li>{{language === 'E' ? 'Education requirements' : '学历要求'}}</li>
                    <li>{{language === 'E' ? 'Monthly salary standard' : '月薪标准'}}</li>
                    <li>{{language === 'E' ? 'Age requirement' : '年龄要求'}}</li>
                </ul>
            </div>
            <div v-for="(item,key) in positionList" :key="key" class="job-list" :class="jobIndex == key ? 'show-job-detail' : ''">
                <ul>
                    <li>{{ item.name }}</li>
                    <li>{{ item.address }}</li>
                    <li>{{ item.time }}</li>
                    <li>{{ item.education }}</li>
                    <li>{{ item.monthly }}</li>
                    <li>{{ item.age }}</li>
                </ul>
                <i class="more-icon" @click="setJobShow(key)" />
                <div class="job-detail">
                    <div class="detail-item">
                        <h5> {{language === 'E' ? 'Job responsibilities:' : '岗位职责：'}}</h5>
                        <ol>
                            <li v-for="(li,i) in item.duty" :key="i">
                                {{ li }}
                            </li>
                        </ol>
                    </div>
                    <div class="detail-item">
                        <h5> {{language === 'E' ? 'Requirements：' : '任职要求：'}}</h5>
                        <ol>
                            <li v-for="(li,i) in item.requirement" :key="i">
                                {{ li }}
                            </li>
                        </ol>
                    </div>
                    <div class="detail-item">
                      {{language === 'E' ? 'Please send your resume to the company email.' : '请将简历投递至公司邮箱 hr@kun-heng.com 。'}}
                    </div>
                </div>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import index from '@/datas/index'
import news from '@/datas/news'
import Eindex from '@/EnglishData/index'
import Enews from '@/EnglishData/news'
export default {
  name: 'aboutMe',
  data () {
    const language = localStorage.getItem('language')
    let languageNews = null
    let languageIndex = null
    if (language && language === 'E') {
      languageNews = Enews
      languageIndex = Eindex
    } else {
      languageNews = news
      languageIndex = index
    }
    const { company } = languageIndex
    const { companyNewsList, positionList } = languageNews
    return {
      companyNewsList,
      language,
      jobIndex: null,
      positionList, // 职位列表
      company // 公司信息
    }
  },
  created () {
  },
  methods: {
    /**
     * 显示某个职位详情
     */
    setJobShow (index) {
      this.jobIndex = index === this.jobIndex ? null : index
    }
  }
}
</script>
<style lang="less" scoped>
.company-list {
  padding: 20px 0 0;
  background-size: 100%;
  position: relative;
  h3,p,h1,h5 {
    color: #111;
  }
  .defult_width,.defult_title {
    position: relative;
    z-index: 2;
  }
  .defult_width {
    text-align: left;
    overflow: hidden;
    h3 {
      line-height: 26px;
      font-size: 16px;
      text-align: left;
    }
    &:last-child h5 {
      font-weight: 800;
      line-height: 26px;
    }
    .company-box {
      text-align: center;
    }
    p {
      margin-top: 30px;
      line-height: 24px;
      text-indent: 2rem;
      text-align: left;
    }
    .company-img {
      margin: 30px auto -15px;
      max-width: 100%;
    }
    // .contact-list {
    //   padding: 20px 0;
    //   border-top: 1px dashed #e5e5e5;
    //   margin-top: 30px;
    //   width: 50%;
    //   float: left;
    //   li {
    //     line-height: 30px;
    //     p {
    //       margin-top: 0;
    //     }
    //   }
    // }
  }
  .industry-news-list {
   padding: 20px 0 50px;
   background: #f7f7f7;
   margin-top: 30px;
  .news-box {
    ul {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      li {
        width: 100%;
        a {
          display: block;
          padding: 20px 0;
          border-bottom: 1px solid #e5e5e5;
          overflow: hidden;
          .img {
            text-align: left;
            width: 20%;
            float: left;
            img {
              width: 216px;
              height: 170px;
            }
          }
          .list {
            width: 80%;
            float: right;
            text-align: left;
            h5 {
              font-size: 18px;
              color: #4a4a4a;
              line-height: 30px;
            }
            p {
              line-height: 24px;
              color: #767676;
            }
            span {
              color: #999;
              display: inline-block;
              padding-top: 20px;
            }
          }
        }
      }
    }

  }

}
  .join-us-box {
      padding-top: 40px;
    .join-us {
        box-shadow: 0 2px .625rem 0 rgba(4,0,0,0.29);
        border-radius: .625rem;
        margin: 0 auto 3.75rem;
        .join-us-title {
            height: 3.125rem;
            background: linear-gradient(90deg,#1e50ae,#1e50ae,rgba(139,10,199,1));
            border-radius: .625rem .625rem 0 0;
            ul {
                height: 100%;
                padding: 0 2.5rem;
                li {
                    width:15%;
                    display: inline-block;
                    line-height: 3.125rem;
                    color: #fff;
                    font-size: .875rem;
                    &:first-child {
                        width: 15%;
                    }
                }
            }
        }
        .job-list {
            position: relative;
            margin: 0 2.5rem;
            border-bottom:  1px solid #E4E4E4;
            &:last-child{
                border-bottom: 0;
            }
            ul {
                height: 100%;
                padding: 1.875rem 0;
                li {
                    width: 15%;
                    display: inline-block;
                    color: #2E2E2E;
                    font-size: .875rem;
                    &:first-child {
                        font-weight: 800;
                        width: 15%;
                    }
                    &:nth-child(4) {
                        color: #787878;
                    }
                    a {
                        width: 5.625rem;
                        height: 1.875rem;
                        text-align: center;
                        line-height: 1.875rem;
                        display: inline-block;
                        border: 1px solid #1e50ae;
                        color: #1e50ae;
                        cursor: pointer;
                        transition: all .2s;
                        &:hover {
                            background: #1e50ae;
                            color: #fff;
                        }
                    }
                }
            }
            .more-icon {
                width: 1.125rem;
                height: .5625rem;
                display: inline-block;
                cursor: pointer;
                position: absolute;
                right: 0;
                top: 2.65rem;
                background: url('~@/assets/images/down.png') no-repeat center center;
                background-size: cover;
                transition: all .4s;
            }
            .job-detail {
                max-height: 0;
                overflow: hidden;
                transition: all .5s;
                .detail-item {
                    padding-bottom: 2.1875rem;
                    color: #3C3A3A;
                    font-size: .875rem;
                    h5 {
                        font-weight: 800;
                        line-height: 2rem;
                    }
                    ol {
                        list-style-type: none;
                        counter-reset: sectioncounter;
                        li {
                            line-height: 2rem;
                            &::before {
                              content:counter(sectioncounter) "、";
                                counter-increment:sectioncounter;
                            }
                        }
                    }
                }
            }

        }
        .show-job-detail {
            .job-detail {
                max-height: 800px;
            }
            .more-icon {
                transform: rotate(180deg);
            }
        }
    }
 }
}
</style>



// WEBPACK FOOTER //
// src/view/aboutMe/aboutMe.vue